/* eslint-disable */
import * as React from "react";
import { useTranslation } from "react-i18next";

// MUI Icons
import DownloadIcon from "@mui/icons-material/Download";

// Custom components
import DialogToolbarMenuItem from "@/ui/Dialog/DialogToolbarMenuItem";

// Types
import { IDialogToolbarMenuItemDetail } from "@/@types/ui/Dialog";


const DialogToolbarMenuItemDownload = React.forwardRef<HTMLLIElement, IDialogToolbarMenuItemDetail>((props, ref) => {
  const { t } = useTranslation();
  const label = props.label ?? String(t("buttons.download"));

  return (
    <DialogToolbarMenuItem label={label} icon={<DownloadIcon />} {...props}ref={ref}/>
  );
});

export default DialogToolbarMenuItemDownload;